import { render } from "./svg-icon.vue?vue&type=template&id=c2929fb2&scoped=true&lang=true"
import script from "./svg-icon.vue?vue&type=script&lang=js"
export * from "./svg-icon.vue?vue&type=script&lang=js"

import "./svg-icon.vue?vue&type=style&index=0&id=c2929fb2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c2929fb2"]])

export default __exports__